import { useCallback } from 'react';

function useCombineDecorators(editor, plugins) {
  return useCallback(function decorate(entry) {
    let ranges = [];
    const addRanges = newRanges => {
      if (newRanges.length) ranges = [...ranges, ...newRanges];
    };
    plugins.forEach(({
      decorate
    }) => {
      if (decorate) {
        addRanges(decorate(entry, editor));
      }
    });
    return ranges;
  }, [editor, plugins]);
}

export { useCombineDecorators };
